<template>
  <div id="app" class="flex container-fluid h-screen w-full flex-row space-around"> 
    <!-- Left sidebar  -->
    <Leftsidebar />
    <!-- Tweets section  -->
    <Mainarea />
    <!-- Trending section  -->
    <Rightsidebar />
  </div>
</template>

<script>
import Leftsidebar from './components/LeftSidebar' 
import Rightsidebar from './components/RightSidebar' 
import Mainarea from './components/MainArea' 

export default {
  name: 'App',
  components: {
    Leftsidebar, 
    Mainarea,
    Rightsidebar
  },

  data(){
    return {

    }
  },
}
</script>

<style>
  /* .container {
  scrollbar-width: thin;
} */
</style>
